module.exports = __webpack_public_path__ + "img/phone_eg.953f492c.png";